const nsEvents = require('@nuskin/events');

const CS_CONFIG_SET = "cs-config-loaded";

/**
 * Just a wrapper over the jQuery getValue (set up by nuskinjquery)
 * to centralize and possibly extend nuskin event handling in general.
 *
 * @param {string} eventId
 * @param {function} eventCallback
 * @param {function} doSubscribe true to listen for the event more than once
 * @memberof nuskin.events
 */
const getValue = (eventId, eventCallback, doSubscribe) => {
    nsEvents.getValue(eventId, eventCallback, doSubscribe);
};

/**
 * Just a wrapper over the jQuery getValue (set up by nuskinjquery)
 * to centralize and possibly extend nuskin event handling in general.
 *
 * @param {string} eventId
 * @param {object} [eventObject]
 * @memberof nuskin.events
 */
const setValue = (eventId, eventObject) => {
    nsEvents.setValue(eventId, eventObject);
};

module.exports = {
    getValue,
    setValue,
    CS_CONFIG_SET
}